<template>
  <div class="home-header">
    <div class="head-title">钢铁退火炉3D可视化数字孪生系统</div>
    <!-- 时间 -->
    <div class="head-time">
      <div class="nowDate">{{ nowDate }}</div>
      <div class="nowTime">{{ nowTime }}</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      nowDate: null, //存放年月日变量
      nowTime: null, //存放时分秒变量
      timer: "", //定义一个定时器的变量
      currentTime: new Date(), // 获取当前时间
    };
  },
  // 实例创建前调用
  created() {
    this.timer = setInterval(this.getCurrentTime, 1000);
  },
  // mounted() {},
  methods: {
    // 获取当前日期时间
    getCurrentTime() {
      const date = new Date();
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const hour = date.getHours();
      const minute = date.getMinutes();
      const second = date.getSeconds();
      if (this.hour > 12) {
        this.hour -= 12;
      }
      this.month = check(month);
      this.day = check(day);
      this.hour = check(hour);
      this.minute = check(minute);
      this.second = check(second);
      function check(i) {
        const num = i < 10 ? "0" + i : i;
        return num;
      }
      this.nowDate = year + "年" + this.month + "月" + this.day + "日";
      this.nowTime = this.hour + ":" + this.minute + ":" + this.second;
    },
  },
  beforeDestroy() {
    // 在Vue实例销毁前清除定时器
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
};
</script>
<style lang="less" scoped>
.home-header {
  padding: 60px 30px 0 24px;
  background: url("./image/header-bg.png") no-repeat 0 0;
  background-size: 100% 80px;
  display: flex;
  justify-content: right;
  align-items: center;
  cursor: default;
  pointer-events: none;
  // 按钮head-time
  .head-tab {
    width: 350px;
    height: 40px;
    // 增加权重
    z-index: 9;
    display: flex;

    div {
      width: 170px;
      height: 40px;
      margin-right: 10px;
      background: url("./image/unselected-bg.png") no-repeat 0 0;
      background-size: 100% 100%;
      font-size: 18px;
      font-weight: 500;
      color: #ffffff;
      text-align: center;
      line-height: 40px;
      cursor: pointer;
    }
  }

  // title
  .head-title {
    width: 100%;
    height: 80px;
    font-size: 46px;
    font-family: TitleFamily;
    text-align: center;
    line-height: 80px;
    color: #ffffff;
    letter-spacing: 1px;
    /* 文字不可选取 */
    user-select: none;
    position: fixed;
    top: 0;
    left: 0;
    pointer-events: none;
  }

  // 时间
  .head-time {
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    // 增加权重
    z-index: 9;
    pointer-events: none;
    .nowDate {
      font-size: 18px;
      font-weight: 400;
      color: #ffffff;
      white-space: nowrap;
    }

    .nowTime {
      height: 25px;
      padding: 0 12px;
      margin-left: 20px;
      font-size: 24px;
      font-weight: 500;
      line-height: 25px;
      color: #ffffff;
      border-left: 2px solid #ffce00;
      white-space: nowrap;
    }
  }
}
</style>